// extracted by mini-css-extract-plugin
export default {"inputContainer":"CustomDiv_inputContainer__jcIIE","inputContainer_textWidth":"CustomDiv_inputContainer_textWidth__SgpmX","mr":"CustomDiv_mr__2E-zZ"};